import React from 'react';
import { Link } from 'react-router-dom';
import { shopInfo } from '../data/mock';
import { Music2, ShoppingBag, Briefcase, ExternalLink, ArrowRight } from 'lucide-react';

const iconMap = {
  Music2: Music2,
  ShoppingBag: ShoppingBag,
  Briefcase: Briefcase
};

const Shop = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="shop" className="py-24 bg-gradient-to-b from-neutral-900 to-black">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-display text-5xl md:text-7xl font-bold uppercase text-white mb-4 tracking-wide">
            {shopInfo.title}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {shopInfo.description}
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {shopInfo.categories.map((category) => {
            const Icon = iconMap[category.icon];
            const isExternal = category.link.startsWith('http');
            const isInternalRoute = category.link.startsWith('/');

            // Pour les liens internes (routes React)
            if (isInternalRoute) {
              return (
                <Link
                  key={category.id}
                  to={category.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative bg-gradient-to-br from-neutral-800 to-neutral-900 border border-neutral-700 rounded-2xl p-8 hover:border-violet-500/50 transition-all duration-300 hover:transform hover:-translate-y-2 cursor-pointer block"
                >
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gradient-to-br from-rose-800 to-violet-800 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon size={32} className="text-white" />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-violet-400 transition-colors">
                    {category.name}
                  </h3>
                  <p className="text-gray-400 mb-6">{category.description}</p>

                  {/* Arrow */}
                  <div className="flex items-center gap-2 text-violet-400 font-medium group-hover:gap-4 transition-all">
                    <span>Découvrir</span>
                    <ArrowRight size={20} />
                  </div>
                </Link>
              );
            }

            // Pour les autres (scroll vers section ou lien externe)
            return (
              <div
                key={category.id}
                className="group relative bg-gradient-to-br from-neutral-800 to-neutral-900 border border-neutral-700 rounded-2xl p-8 hover:border-violet-500/50 transition-all duration-300 hover:transform hover:-translate-y-2 cursor-pointer"
                onClick={() => {
                  if (isExternal) {
                    window.open(category.link, '_blank');
                  } else {
                    scrollToSection(category.link);
                  }
                }}
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-rose-800 to-violet-800 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <Icon size={32} className="text-white" />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-violet-400 transition-colors">
                  {category.name}
                </h3>
                <p className="text-gray-400 mb-6">{category.description}</p>

                {/* Arrow */}
                <div className="flex items-center gap-2 text-violet-400 font-medium group-hover:gap-4 transition-all">
                  <span>Découvrir</span>
                  {isExternal ? <ExternalLink size={20} /> : <ArrowRight size={20} />}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Shop;